import { ArrowRight, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section 
      id="hero"
      className="relative min-h-screen flex items-center hero-bg pt-20"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1688263246963-5815e9dabfc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxtdWx0aWZhbWlseSUyMGFwYXJ0bWVudCUyMGNvbXBsZXglMjBjb3VydHlhcmQlMjBsYW5kc2NhcGluZyUyMGNsZWFufGVufDB8fHx8MTc3NTY3Mjc2NHww&ixlib=rb-4.1.0&q=85')`
      }}
      data-testid="hero-section"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 lg:py-32">
        <div className="max-w-3xl">
          {/* Tagline Badge */}
          <div className="inline-flex items-center gap-2 bg-cyan-500/20 border border-cyan-400/30 rounded-full px-4 py-2 mb-8">
            <span className="text-cyan-300 font-semibold text-sm tracking-wide uppercase">
              Factory to Finish
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6">
            Your One Stop Solution for{" "}
            <span className="text-cyan-400">Multifamily Interiors</span>
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed mb-8 max-w-2xl">
            We deliver high quality interiors at the best prices with efficient execution, 
            empowering partners to achieve higher returns on their investments.
          </p>

          {/* Key Points */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 mb-10">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-cyan-400" />
              <span className="text-white font-medium">27% Below Market</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-cyan-400" />
              <span className="text-white font-medium">3+ Units/Day</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-cyan-400" />
              <span className="text-white font-medium">Turnkey Solution</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              onClick={scrollToContact}
              className="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-8 py-6 text-lg rounded-md group"
              data-testid="hero-cta-primary"
            >
              Get a Quote
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => {
                const element = document.querySelector("#services");
                if (element) element.scrollIntoView({ behavior: "smooth" });
              }}
              className="border-white/30 text-white hover:bg-white/10 font-semibold px-8 py-6 text-lg rounded-md"
              data-testid="hero-cta-secondary"
            >
              Our Services
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-white/60 rounded-full mt-2 animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
